import React from "react";
import Nav from "react-bootstrap/Nav";
import { Link } from "react-router-dom";
// import logo from "../assets/img/logo.svg";

function Footer() {
  const currentYear = new Date().getFullYear();
  return (
    <footer>
      <footer class="footer-4 footer-wrap">
        <div class="footer-widgets">
          <div class="container">
            <div class="row justify-content-between">
              <div class="col-md-6 col-xl-3 col-12 pr-xl-4">
                <div className="single-footer-wid site_footer_widget text-center">
                  <a href="index.html">
                    <img
                      // src={logo}
                      src="/assets/img/logo.svg"
                      alt="DNK Software"
                      className="object-contain mx-auto"
                      style={{ height: "150px" }}
                    />
                  </a>
                  <p className="mt-4 text-gray-600 text-sm">
                    DNK Software Pvt Ltd, We build technology solutions that solve complex business challenges and help businesses grow.
                  </p>
                  <div className="social-link mt-6 flex justify-center space-x-4">
                    <a href="#" className="text-gray-500 hover:text-blue-600">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href="#" className="text-gray-500 hover:text-blue-400">
                      <i className="fab fa-twitter"></i>
                    </a>
                    <a href="#" className="text-gray-500 hover:text-red-600">
                      <i className="fab fa-youtube"></i>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-md-6 col-xl-2 col-12">
                <div class="single-footer-wid">
                  <div class="wid-title">
                    <h4>Company</h4>
                  </div>
                  <Nav as="ul">
                    <Nav.Item as="li">
                      <Nav.Link as={Link} to="/">
                        Home
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link as={Link} to="/about">
                        About
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link as={Link} to="/services">
                        Services
                      </Nav.Link>
                    </Nav.Item>
                    <Nav.Item as="li">
                      <Nav.Link as={Link} to="/contact">
                        Contact
                      </Nav.Link>
                    </Nav.Item>
                    {/* <Nav.Item as="li">
                      <Nav.Link as={Link} to="/dnyaneshwarmohol">
                        Card
                      </Nav.Link>
                    </Nav.Item> */}
                  </Nav>
                </div>
              </div>
              {/* <div class="col-md-6 col-xl-2 col-12">                        
                        <div class="single-footer-wid">
                            <div class="wid-title">
                                <h4>Useful Link</h4>
                            </div>
                            <ul>
                                <li><a href="about.html">About Us</a></li>
                                <li><a href="about.html">Company History</a></li>
                                <li><a href="contact.html">Need a Career</a></li>
                                <li><a href="project-details.html">Working Process</a></li>
                                <li><a href="news.html">Blog Post</a></li>
                            </ul>
                        </div>
                    </div> */}
            </div>
          </div>
        </div>

        <div class="footer-bottom">
          <div class="container text-center">
            <div class="footer-bottom-content">
              © 2026 DNK Software Pvt. Ltd
            </div>
          </div>
        </div>
      </footer>
    </footer>
  );
}

export default Footer;
